import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//import context provider  // wrap the whole <App /> inside this provider
import { UserContextProvider } from './Context/UserContext';

ReactDOM.render(
  <React.StrictMode>

    <UserContextProvider>
      <App />
    </UserContextProvider>
    
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
